import Typography from '@mui/material/Typography';
import styled, { css } from 'styled-components';

// wraps a caller-supplied read view so click-to-edit has something to attach to
export const ReadViewContainer = styled.div`
  cursor: text;
  min-width: 0;
`;

// the default `linkComponent` — consumers only pass their own when the colour differs
export const ParsedLink = styled.a`
  display: inline-block;
  max-width: 20rem;

  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    text-decoration: underline;
  }
`;

export const UrlParser = styled(Typography)<{
  $explicitTextCursor: boolean;
  $hasPaddingRight: boolean;
  $respectNewLines: boolean;
}>`
  ${({ theme, $hasPaddingRight }) =>
    $hasPaddingRight &&
    css`
      padding-right: ${theme.spacing(2.5)};
    `};
  ${({ $explicitTextCursor }) =>
    $explicitTextCursor &&
    css`
      cursor: text;
    `};
  ${({ $respectNewLines }) =>
    $respectNewLines &&
    css`
      white-space: pre-line;
    `};
`;
